import { colors } from 'theme'

export const defaultThemeStyles: {
    border: string
    background: string
} = {
    border: colors.greyLight,
    background: colors.white,
}
